import React, { useState } from 'react';
import { ChevronDown, ChevronUp, Share2 } from 'lucide-react';

const MODES = {
  email: 'Email',
  member_space: 'Espace Membre',
  cooper_space: "Espace COOPER'S",
  expert_space: 'Espace Expert',
};

const fmt = (d) => (d ? new Date(d).toLocaleString('fr-FR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');

export default function HistoriquePartages({ convention }) {
  const [open, setOpen] = useState(false);
  const partages = [...(convention.shares || [])].sort((a, b) => String(b.shared_at).localeCompare(String(a.shared_at)));
  const testid = `convention-shares-${convention.id}`;
  return (
    <div className="mt-3 rounded-lg border border-slate-200 bg-white" data-testid={testid}>
      <button
        type="button"
        onClick={() => setOpen((o) => !o)}
        className="w-full flex items-center justify-between px-3 py-2 text-xs font-semibold text-slate-600 uppercase"
        data-testid={`${testid}-toggle`}
      >
        <span className="flex items-center gap-2"><Share2 className="h-3.5 w-3.5" /> Historique des partages ({partages.length})</span>
        {open ? <ChevronUp className="h-4 w-4" /> : <ChevronDown className="h-4 w-4" />}
      </button>
      {open && (
        <div className="px-3 pb-3">
          {partages.length === 0 ? (
            <p className="text-xs text-slate-500" data-testid={`${testid}-empty`}>Aucun partage pour cette convention.</p>
          ) : (
            <table className="w-full text-xs">
              <thead>
                <tr className="text-left text-slate-500">
                  <th className="py-1 pr-2">Date</th><th className="py-1 pr-2">Mode</th><th className="py-1">Destinataire</th>
                </tr>
              </thead>
              <tbody>
                {partages.map((p, i) => (
                  <tr key={p.id || i} className="border-t border-slate-100 text-slate-700" data-testid={`${testid}-row-${i}`}>
                    <td className="py-1 pr-2 whitespace-nowrap">{fmt(p.shared_at)}</td>
                    <td className="py-1 pr-2">{MODES[p.share_type] || p.share_type || '—'}</td>
                    <td className="py-1 break-all">{p.destinataire || p.recipient_email || convention.destinataire_nom || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      )}
    </div>
  );
}
